import Link from 'next/link'

type Breadcrumb = {
  label: string
  href: string
}
interface BreadcrumbType {
  breadcrumbs: Breadcrumb[]
  className?: string
  homeText?: string
}

const PageBreadcrumb = ({ breadcrumbs, homeText = 'Trang chủ', className = '' }: BreadcrumbType) => {
  return (
    <div className={`breadCrumb ${className}`}>
      <ul className='flex items-center gap-1.5 py-3 text-sm text-dark-100'>
        <li key='breadcrumb-10000'>
          <Link href='/' className='home block'>
            {homeText}
          </Link>
        </li>
        <li className='divider'>{'>'}</li>
        {breadcrumbs.map((e: Breadcrumb, index: number) => (
          <li className='divider' key={`breadcumb-${e.label}`}>
            <Link href={e.href} className='home block'>
              {e.label}
            </Link>
            {index > 0 && <span className='divider'>{'>'}</span>}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default PageBreadcrumb
